export const CLASS_NAME = 'cst-year-picker'
